import { useState } from 'react';
import FilteredPrizeList from './FilteredPrizeList';
import { SearchFilter } from './SearchFilter';
import { useAllPrizesPageStore } from 'hooks/stores/useAllPrizesPageStore';

interface SearchResultsProps {
  term?: string;
}

const SearchResults = (props: SearchResultsProps) => {
  const [loading, setLoading] = useState(false);
  const allPrizesPageStore = useAllPrizesPageStore();

  const initialCriteria = {
    term: props.term,
  };
  const [prizeCount, setPrizeCount] = useState<number | undefined>(
    allPrizesPageStore.getTotalMatchingPrizes(initialCriteria),
  );

  return (
    <FilteredPrizeList
      headerComponent={
        <SearchFilter
          resultsPage={true}
          resultCount={prizeCount}
          searchInput={props.term}
          loadingResults={loading}
          placeholder="I'm looking for..."
          filterType="category"
        />
      }
      showPrizeTierBadges
      term={props.term}
      onPrizeCountChange={(newPrizeCount) => setPrizeCount(newPrizeCount)}
      onLoadingChange={(newLoadingStatus) => setLoading(newLoadingStatus)}
    />
  );
};

export default SearchResults;
